module.exports = __webpack_public_path__ + "img/z19.318a9724.png";